import Collapse from 'antd/lib/collapse'
import classes from './LiveFeedbackDetails.module.less'
import { LiveFeedbackDetailsType } from 'Types/LiveFeedback.types'
import Flex from 'antd/lib/flex'
import { InfoCircleFilled } from '@ant-design/icons'
import LiveFeedbackNoteIcon from 'Assets/icons/live-feedback-note.svg?react'
import Tooltip from 'antd/lib/tooltip'

const { Panel } = Collapse

export type LiveFeedbackDetailsProps = {
    details?: LiveFeedbackDetailsType[]
    activeIndex?: number
    onCollapseChange?: (key: string | string[]) => void
    isViolationHighlighted: boolean
    parameterFeedback: Record<string, boolean>
}

export const LiveFeedbackDetails: React.FC<LiveFeedbackDetailsProps> = (
    props: LiveFeedbackDetailsProps
) => {
    return (
        !!props.details?.length && (
            <div className={classes.liveFeedbackDetails}>
                <div className={classes.feedbackNote}>
                    <Flex align="center" gap={2}>
                        <LiveFeedbackNoteIcon />
                        <span className={classes.feedbackNoteText}>
                            Please go through the below feedback
                        </span>
                    </Flex>
                    <Tooltip
                        placement="bottom"
                        title="Use this AI-generated feedback as guidance, keeping in mind it may occasionally be inaccurate."
                    >
                        <InfoCircleFilled className={classes.feedbackNoteIcon} />
                    </Tooltip>
                </div>
                <Collapse
                    defaultActiveKey={[0]}
                    accordion={true}
                    className={classes.feedbackCollapse}
                    expandIconPosition="end"
                    onChange={props.onCollapseChange}
                >
                    {props.details.map((detail, index) => {
                        const shouldHighlight =
                            props.parameterFeedback[detail.id] === undefined &&
                            props.isViolationHighlighted
                        const collapseHeaderClass = shouldHighlight
                            ? classes.collapseHeader + ' ' + classes.highlighted
                            : classes.collapseHeader
                        return (
                            <>
                                <Panel
                                    header={`${index + 1}. ${detail.title}`}
                                    key={index}
                                    className={collapseHeaderClass}
                                >
                                    <div className={classes.panelContent}>
                                        <div className={classes.rating}>
                                            {typeof detail.prediction === 'number'
                                                ? `${detail.prediction} out of 5`
                                                : detail.prediction}
                                        </div>
                                        <div className={classes.feedback}>{detail.value}</div>
                                    </div>
                                </Panel>
                                <div className={classes.divider}></div>
                            </>
                        )
                    })}
                </Collapse>
            </div>
        )
    )
}
